import { Box, BoxProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

const useStyles = makeStyles()(() => ({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
  },
}));

export interface VisuallyHiddenProps extends Pick<BoxProps, 'component'> {
  id?: string;
  children?: BoxProps['children'];
}

/**
 * Implementation of material-ui's `visuallyHidden`. This should be used when there needs to be
 * extra context for screen-readers if what's available is not enough.
 *
 * @see https://github.com/mui-org/material-ui/blob/f1bcacd504/packages/material-ui-utils/src/visuallyHidden.ts
 *
 */
export default function VisuallyHidden({
  children = '',
  component = 'span',
  ...rest
}: PropsWithChildren<VisuallyHiddenProps>) {
  const { classes } = useStyles();

  return (
    <Box component={component} className={classes.visuallyHidden} {...rest}>
      {children}
    </Box>
  );
}
